import React from "react"
import FormGroup from "../../../Form/FormGroup"
import Textarea from "../../../Form/Textarea"
import Select from "../../../Form/Select"

const optionsBoolean = [
    { id: 1, value: "Sim" },
    { id: 0, value: "Não" },
]

const CloseConversation = ({ data = {}, onChange = () => { } }) => {
    const handleChangeContent = (name, value) => {
        onChange(name, value)
    }

    return (
        <FormGroup>
            <FormGroup labelText="Mensagem final">
                <Textarea
                    placeholder="Ex: Obrigado pelo contato! Encerramos seu atendimento."
                    onChange={(e) => handleChangeContent("final_message", e.target.value)}
                    value={data?.final_message || ""}
                    rows={3}
                />
            </FormGroup>
            <FormGroup labelText="Gerar resumo da conversa? (O resumo ficará salvo como uma mensagem interna ao fim da conversa)">
                <Select
                    name="Gerar resumo da conversa?"
                    placeholder="Selecione uma opção..."
                    options={optionsBoolean}
                    selected={Number(data.generate_summary ?? "")}
                    onChange={(value) => handleChangeContent("generate_summary", Number(value))}
                    multiple={false}
                />
            </FormGroup>
        </FormGroup>
    )
}

export default CloseConversation